// @flow

import _get from 'lodash/get';

import type { PartialOrganization, Product } from '@gandi/cart';

export function mustCartOwnerBeReseller(
  hasOwnerOnly: boolean,
  cartOwnerList: Array<PartialOrganization>,
): boolean {
  return hasOwnerOnly && _get(cartOwnerList, '[0].reseller', false);
}

export const isProductResellable = ({
  productType,
  process,
}: Product): boolean =>
  (productType === 'domain' && ['create', 'transfer'].includes(process)) ||
  (productType === 'certificate' && process === 'create');

export const canChooseProductOwner = ({
  productType,
  process,
}: Product): boolean =>
  (process === 'create' &&
    ['domain', 'paas', 'certificate'].includes(productType)) ||
  (productType === 'cloud' && process === 'add');

export const isProductAutorenewable = ({
  productType,
  process,
}: Product): boolean =>
  (productType === 'domain' && ['create', 'transfer'].includes(process)) ||
  (productType === 'paas' && process === 'create');

export const canChooseProductContacts = ({
  productType,
  process,
}: Product): boolean =>
  productType === 'domain' && ['create', 'transfer'].includes(process);
